export default function mapper(deficiency) {
    var _a, _b, _c, _d, _e, _f;
    const apiPayload = {};
    // Map the fields that exist in deficiency to their API counterparts
    if (deficiency.isResolved !== undefined) {
        apiPayload.is_resolved = deficiency.isResolved;
    }
    if (deficiency.deficiencyResolutionStatus !== undefined && deficiency.deficiencyResolutionStatus !== null) {
        apiPayload.deficiency_resolution_status_id = deficiency.deficiencyResolutionStatus;
    }
    if (deficiency.resolutionNotes !== undefined) {
        apiPayload.resolution_notes = (_a = deficiency.resolutionNotes) !== null && _a !== void 0 ? _a : '';
    }
    if (deficiency.dateResolved !== undefined) {
        apiPayload.date_resolved = (_b = deficiency.dateResolved) !== null && _b !== void 0 ? _b : '';
    }
    if (deficiency.deficiencyStatus !== undefined) {
        apiPayload.deficiency_status = (_c = deficiency.deficiencyStatus) !== null && _c !== void 0 ? _c : '';
    }
    if (deficiency.note !== undefined) {
        apiPayload.notes = deficiency.note;
    }
    if (deficiency.internalNote !== undefined) {
        apiPayload.internal_notes = deficiency.internalNote;
    }
    if (deficiency.resolvedTechnicianName !== undefined) {
        apiPayload.resolved_technician_name = (_d = deficiency.resolvedTechnicianName) !== null && _d !== void 0 ? _d : '';
    }
    if (deficiency.tagList !== undefined) {
        apiPayload.tag_list = (_e = deficiency.tagList) !== null && _e !== void 0 ? _e : [];
    }
    if (deficiency.displayName !== undefined) {
        apiPayload.display_name = deficiency.displayName;
    }
    if (deficiency.ulcReferenceClause !== undefined) {
        apiPayload.ulc_reference_clause = (_f = deficiency.ulcReferenceClause) !== null && _f !== void 0 ? _f : '';
    }
    return apiPayload;
}
